import * as React from 'react'

const EventsIcon = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
  >
    <path
      d="M4.00176 5.5H6.00176M5.00176 4.5V6.5M11.5018 4.5L11.0018 6.5M18.0018 5.5H20.0018M19.0018 4.5V6.5M15.0018 9.5L14.0018 10.5M18.0018 13.5L20.0018 13M18.0018 19.5H20.0018M19.0018 18.5V20.5M14.0018 17.018L7.48376 10.5L3.09376 20.08C3.00699 20.266 2.97955 20.4742 3.01518 20.6763C3.0508 20.8785 3.14776 21.0647 3.29289 21.2099C3.43802 21.355 3.6243 21.452 3.82643 21.4876C4.02856 21.5232 4.23676 21.4958 4.42276 21.409L14.0018 17.018Z"
      stroke="#4F5B94"
      stroke-width="1.25"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
)

export default EventsIcon
